import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Container, Grid } from "@mui/material";

import tmsActions from "../../../../actions/tmsActions";
import { getMyCourses, isFetching, isSending } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import Fetching from "../../../Common/Fetching";
import CourseCard from "../Course/CourseCard";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import BreadcrumbBuilder from "../BreadcrumbBuilder";

const appCode = "C-TMS";

function MyEnrolments({ isFetching, courses, onDelete }) {
    const [openDialog, setOpenDialog] = useState(null);
    const [selectedEnrolment, setSelectedEnrolment] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState(null);

    const handleOpenDeleteDialog = (enrolment) => () => {
        setSelectedEnrolment(enrolment);
        setSelectedTitle(
            (enrolment.course && enrolment.course.name) ||
                `Enrolment ${enrolment.id}`
        );
        setOpenDialog("delete");
    };

    const handleCloseDialog = useCallback(() => {
        setOpenDialog(null);
        setSelectedTitle(null);
        setSelectedEnrolment(null);
    }, []);

    return (
        <Container className="content">
            <Grid
                container
                spacing={3}
                alignItems="stretch"
                className="card-grid"
            >
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isFetching && (
                    <Grid item md={12}>
                        <Fetching />
                    </Grid>
                )}

                {courses &&
                    courses.map((course) => (
                        <Grid
                            item
                            lg={12}
                            xl={6}
                            key={course.id}
                            className="card-grid-item"
                        >
                            <CourseCard
                                course={course}
                                onDeleteEnrolment={handleOpenDeleteDialog(
                                    course.enrolment
                                )}
                            />
                        </Grid>
                    ))}
            </Grid>

            {openDialog === "delete" && !!selectedEnrolment && (
                <ConfirmDialog
                    open={true}
                    title="Unenroll from course"
                    content={`The following enrolment will be cancelled: ${selectedTitle}`}
                    confirmButtonLabel="Unenroll"
                    onConfirm={() => onDelete(selectedEnrolment.id)}
                    onCancel={handleCloseDialog}
                    onClose={handleCloseDialog}
                />
            )}
        </Container>
    );
}

const MyEnrolmentsContainer = () => {
    const courses = useSelector(getMyCourses);
    const isFetchingCourses = useSelector((state) =>
        isFetching(state, DataTypes.TMS_COURSES)
    );
    const isUploading = useSelector((state) =>
        isSending(state, DataTypes.TMS_COURSES)
    );
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(tmsActions.getEnrolments(appCode));
    }, [dispatch]);

    useEffect(() => {
        if (!isUploading) {
            dispatch(tmsActions.getEnrolments(appCode));
        }
    }, [isUploading, dispatch]);

    const onDelete = useCallback(
        (id) => {
            dispatch(tmsActions.deleteEnrolment(appCode, id));
        },
        [dispatch]
    );

    return (
        <MyEnrolments
            isFetching={isFetchingCourses}
            courses={courses}
            onDelete={onDelete}
        />
    );
};

export default MyEnrolmentsContainer;
